<template>
  <div
    class="pcoded iscollapsed"
    nav-type="st6"
    theme-layout="vertical"
    vertical-placement="left"
    vertical-layout="wide"
    pcoded-device-type="desktop"
    v-bind:vertical-nav-type="nav"
    vertical-effect="shrink"
    vnavigation-view="view1"
    fream-type="theme1"
    sidebar-img="false"
    sidebar-img-type="img1"
    layout-type="light"
  >
    <div class="pcoded-overlay-box"></div>
    <router-view />
  </div>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

// Navbar logic
const nav = ref('expanded')

// Shortcuts logic
let isControl = ref(false)
const isEditableTarget = (element) => {
  if (!element || typeof element.tagName !== 'string') return false
  // Native form fields (tagName is uppercase in HTML, normalize for safety)
  const tag = element.tagName.toUpperCase()
  if (['INPUT', 'TEXTAREA', 'SELECT'].includes(tag)) return true
  // Any contenteditable region (e.g., CKEditor)
  if (element.isContentEditable) return true
  // CKEditor containers
  const editableContainer = element.closest(
    '[contenteditable="true"], .ck, .ck-editor, .ck-editor__editable, .ck-content'
  )
  return !!editableContainer
}

const handleKeyDown = (event) => {
  if (event.key == 'Control') {
    isControl.value = true
    return
  } else if (event.key === 'Backspace') {
    const target = event.target
    const active = document.activeElement
    if (isEditableTarget(target) || isEditableTarget(active)) return
    event.preventDefault() // Prevent default behavior of backspace
    window.history.back() // Go back to the previous page
    return
  }
}

const handelKeyUp = (event) => {
  if (event.key == 'Control') {
    isControl.value = false
    return
  }
}

onMounted(() => {
  window.addEventListener('keydown', handleKeyDown)
  window.addEventListener('keyup', handelKeyUp)
})
onBeforeUnmount(() => {
  // Clean up the event listener when the component is unmounted
  window.removeEventListener('keydown', handleKeyDown)
  window.removeEventListener('keyup', handelKeyUp)
})
</script>
